/**
 * /maintenance
 */
import { useQuery } from '@tanstack/react-query'
import { CalendarClock } from 'lucide-react'
import { PageHeader } from '@/components/app-shell'
import { Card } from '@/components/ui/card'
import { EmptyState } from '@/components/ui/empty-state'
import { StatusPill } from '@/components/ui/status-pill'
import { listMaintenance } from '@/lib/api'

export function MaintenancePage() {
  const query = useQuery({ queryKey: ['maintenance'], queryFn: () => listMaintenance() })
  const rows = query.data?.schedules ?? []

  return (
    <>
      <PageHeader
        title="Maintenance"
        subtitle="Programas preventivos · Overdue / Due Soon / OK"
      />

      {query.isLoading ? (
        <p className="text-sm text-muted-foreground">Cargando…</p>
      ) : rows.length === 0 ? (
        <Card>
          <EmptyState
            icon={CalendarClock}
            title="Sin programas"
            description="Crea programas desde la API o añade uno en una próxima iteración de UI."
          />
        </Card>
      ) : (
        <Card className="divide-y divide-border overflow-hidden">
          {rows.map((r) => (
            <div key={r.id} className="flex min-h-[60px] items-center gap-3 px-4 py-3">
              <span className="min-w-0 flex-1">
                <span className="block text-sm font-medium">
                  Unit {r.unitNumber} · {r.maintenanceName}
                </span>
                <span className="block text-xs text-muted-foreground">
                  {r.nextDueDate ? `Due ${r.nextDueDate}` : 'Sin fecha'}
                  {r.nextDueOdometer != null
                    ? ` · ${r.nextDueOdometer.toLocaleString()} ${r.odometerUnit}`
                    : ''}
                </span>
              </span>
              <StatusPill status={r.dueState} />
            </div>
          ))}
        </Card>
      )}
    </>
  )
}
